import { useEffect, useState } from 'react';
import { getPendingRequestCount } from './pendingRequestCountGateway';

export interface GetPendingRequestCountResponse {
    count: number;
}

const usePendingRequestCount = (pendingRequestsEndpoint: string): GetPendingRequestCountResponse => {
    const [count, setCount] = useState<number>(0);

    useEffect(() => {
        const fetch = async (): Promise<void> => {
            try {
                const pendingRequestCount = await getPendingRequestCount(pendingRequestsEndpoint);
                setCount(pendingRequestCount);
            } catch {
                setCount(0);
            }
        };

        void fetch();
    }, []);

    return { count };
};

export { usePendingRequestCount };
